/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import MUISelectInput from '@brands/Components/Inputs/MuiSelectInput/MUISelectInput';
import TextField from '@brands/Components/Inputs/MuiTextField/TextField';
import ValidateAddressModal from '@brands/Dashboard/MyProfile/Patient/Sections/ValidateAddressModal/ValidateAddressModal';
import { stateOptions } from '@brands/Utils/selectOptions';
import { ValidationModalInterface } from '@brands/Utils/validateAddress';
import React from 'react';
import {
  FieldErrors,
  UseFormClearErrors,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';

import styles from '../../Profile/styles.module.scss';
import { DependentPatientSubmit } from '../EditDependent';

interface AddressSectionProps {
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  getValues: UseFormGetValues<any>;
  setTextValue: (e: React.ChangeEvent<HTMLInputElement>, name: string) => void;
  setValue: UseFormSetValue<any>;
  showValidationAddressModal: ValidationModalInterface;
  clearErrors: UseFormClearErrors<DependentPatientSubmit>;
  required: boolean;
  watch: UseFormWatch<DependentPatientSubmit>;
}

const AddressSection: React.FC<AddressSectionProps> = ({
  register,
  errors,
  getValues,
  setTextValue,
  setValue,
  clearErrors,
  required,
  watch,
  showValidationAddressModal,
}): JSX.Element => {
  return (
    <>
      <div className={styles.inputWrapRow}>
        <div className={styles.inputWrap}>
          <TextField
            {...register('address1')}
            label="Address"
            value={getValues('address1')}
            data-testid="dependent-address1"
            errors={errors.address1 ? errors : {}}
            name="address1"
            onChange={(e: any) => {
              if (errors.address1) clearErrors('address1');
              setValue('address1', e.target.value, { shouldValidate: true });
            }}
            required
            inputClass={`${styles.profileInputClass} fs-exclude`}
            wrapperClassName={`fs-unmask ${styles.completeProfileAddress}`}
          />
        </div>
        <div className={styles.inputWrap}>
          <TextField
            {...register('address2')}
            value={getValues('address2')}
            data-testid="dependent-address2"
            label="Apartment, suite, etc. (optional)"
            errors={errors.address2 ? errors : {}}
            name="address2"
            onChange={(e: any) => {
              if (errors.address2) clearErrors('address2');
              setValue('address2', e.target.value, { shouldValidate: true });
            }}
            inputClass={`${styles.profileInputClass} fs-exclude`}
            wrapperClassName={`fs-unmask ${styles.completeProfileAddress2}`}
          />
        </div>
      </div>
      <div className={`${styles.inputWrapRow} ${styles.inputWrapEqualRow}`}>
        <div className={styles.inputWrap}>
          <TextField
            {...register('city')}
            label="City"
            data-testid="dependent-city"
            value={watch('city')}
            errors={errors.city ? errors : {}}
            name="city"
            onChange={(e: any) => {
              if (errors.city) clearErrors('city');
              setValue('city', e.target.value, { shouldValidate: true });
            }}
            required
            inputClass={`${styles.profileInputClass} fs-exclude`}
            wrapperClassName={`fs-unmask ${styles.completeProfileClass}`}
          />
        </div>
        <div className={styles.inputWrap}>
          <MUISelectInput
            {...register('state')}
            label="State"
            data-testid="dependent-state"
            errors={errors.state ? errors : {}}
            name="state"
            onChange={(e: any) => {
              if (errors.state) clearErrors('state');
              setValue('state', e);
            }}
            value={watch('state') || ''}
            required
            inputClass={`${styles.profileInputClass} fs-exclude`}
            wrapperClassName={`fs-unmask ${styles.completeProfileClass}`}
            options={stateOptions}
          />
        </div>
        <div className={styles.inputWrap}>
          <TextField
            {...register('zip_code')}
            label="Zip code"
            data-testid="dependent-zipcode"
            errors={errors.zip_code ? errors : {}}
            name="zip_code"
            value={getValues('zip_code')}
            onChange={(e: any) => {
              if (errors.zip_code) clearErrors('zip_code');
              setValue('zip_code', e.target.value, { shouldValidate: true });
            }}
            required
            inputClass={`${styles.profileInputClass} fs-exclude`}
            wrapperClassName={`fs-unmask ${styles.completeProfileClass}`}
          />
        </div>
      </div>
      <ValidateAddressModal
        title={showValidationAddressModal.title}
        isOpen={showValidationAddressModal.isOpen}
        recommended={showValidationAddressModal.recommended}
        recommendedAddress={showValidationAddressModal.recommendedAddress}
        whatYouEntered={showValidationAddressModal.whatYouEntered}
        onClose={showValidationAddressModal.onClose}
        onKeepCurrentAddress={showValidationAddressModal.onKeepCurrentAddress}
        onConfirmChange={showValidationAddressModal.onConfirmChange}
      />
    </>
  );
};

export default AddressSection;
